<template>
  <div>
    <div @click="toggleDropdown">
      <feather-icon
        id="notificationPopover"
        ref="notificationDropdownTrigger"
        :badge="unReadNotifications"
        badge-classes="bg-warning"
        class="text-body text-warning dropdown-notification mr-25"
        icon="BellIcon"
        size="21"
      />
    </div>

    <b-popover
      ref="notificationDropdown"
      :key="unReadNotifications"
      target="notificationPopover"
      triggers="focus"
      placement="bottomright"
      custom-class="notification-popover list-group"
      @shown="notificationShown = true"
      @hidden="notificationShown = false"
      @refetch="getNotifications(false)"
    >
      <notification-body @close-dropdown="toggleDropdown" />
    </b-popover>

    <b-modal
      id="mark-all-as-read"
      title="Mark All Notification as Read"
      ok-title="Confirm"
      ok-variant="success"
      ok-only
      hide-cancel
      @ok="markAllAsRead"
    >
      <p>
        Are you sure you want mark all notification as read ?
      </p>
    </b-modal>

    <!-- Action Modals -->
    <NotificationWalletShareModal
      v-if="notification && notification.notification && notification.notification.__typename === 'NotificationWalletShareInvite' && notification.notification.walletShareInviteAction === 'REQUESTED'"
      :notification="notification"
      :modal-id="notificationModalId"
      @hidden="notification = null; notificationModalId = null;"
    />

    <NotificationInvoiceVerificationModal
      v-if="notification && notification.notification && notification.notification.__typename === 'NotificationInvoiceVerification' && notification.notification.verificationAction === 'REQUESTED'"
      :notification="notification"
      :modal-id="notificationModalId"
      @hidden="notification = null; notificationModalId = null;"
    />

    <NotificationPaidInvoiceVerificationModal
      v-if="notification && notification.notification && notification.notification.__typename === 'NotificationPaidInvoiceVerification' && notification.notification.verificationAction === 'REQUESTED'"
      :notification="notification"
      :modal-id="notificationModalId"
      @hidden="notification = null; notificationModalId = null;"
    />
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import EventBus from '@/event-bus'
import NotificationBody from './NotificationBody.vue'
import NotificationWalletShareModal from './notification-action-modals/NotificationWalletShareModal.vue'
import NotificationInvoiceVerificationModal from './notification-action-modals/NotificationInvoiceVerificationModal.vue'
import NotificationPaidInvoiceVerificationModal from './notification-action-modals/NotificationPaidInvoiceVerificationModal.vue'

export default {
  components: {
    NotificationBody,
    BPopover,
    NotificationWalletShareModal,
    NotificationInvoiceVerificationModal,
    NotificationPaidInvoiceVerificationModal,
  },
  data() {
    return {
      notificationShown: false,
      notification: null,
      notificationModalId: null,
    }
  },
  computed: {
    unReadNotifications() {
      return this.$store.state.notification.unReadNotifications > 0 ? this.$store.state.notification.unReadNotifications : 0
    },
  },
  mounted() {
    this.getNotifications(true)

    EventBus.$on('notification-action', ({ modalId, notification }) => {
      this.notification = notification
      this.notificationModalId = modalId
    })
  },
  beforeDestroy() {
    EventBus.$off('notification-action')
  },
  methods: {
    markAllAsRead() {
      const project = this.$store.state.project?.project
      useApollo.users.markAllNotificationsAsRead({
        projectUid: project.uuid,
        typeFilter: {
          blacklist: ['Task*', 'Board*'],
        },
      }).then(() => {
        this.$store.dispatch('notification/setUnreadNotification', 0)
      })
    },
    async getNotifications(initial = false) {
      this.showSkeleton = initial
      this.isProcessing = true
      const project = this.$store.state.project?.project
      await this.$store.dispatch('notification/fetchNotifications', { projectUid: project.uuid })
      this.isProcessing = false
      this.showSkeleton = false
    },
    toggleDropdown() {
      if (this.notificationShown) {
        this.$root.$emit('bv::hide::popover', 'notificationPopover')
        this.notificationShown = false
        this.$refs.notificationDropdownTrigger.blur()
      } else {
        this.$refs.notificationDropdownTrigger.focus()
        this.$root.$emit('bv::show::popover', 'notificationPopover')
      }
    },
  },
}
</script>

<style lang="scss">
.notification-popover {
  max-width: 30vw !important;
  width: 30vw !important;

  .popover-body {
    padding: 0;
    border-top: 0px solid #3D61AD;
    border-radius: 6px 6px 0 0 !important;

    .notification-card.notification-card--active{
      background-color: #f8f8f8;
    }
  }
}

.dark-layout {
  .notification-popover {
    .popover-body {
      .notification-card.notification-card--active{
        background-color: #161d31;
      }
    }
  }
}
</style>
